import { memo } from "react";

import { type TTailwindString, tw } from "classnames";

const styles = {
  base: tw("flex", "gap-3", "h-[33px]" as TTailwindString),
  button: tw(
    "shrink-0",
    "h-8",
    "w-32",
    "rounded-full",
    "bg-placeholder",
    "animate-pulse",
    "border-2",
    "border-solid",
    "border-transparent"
  ),
};

const CollectionAdjacentCollectionsPlaceholderBase = () => {
  return (
    <div className={styles.base}>
      {Array.from({ length: 6 }).map((_, index) => (
        <div
          className={styles.button}
          key={`placeholder-adjacentButtons-${index}`}
        ></div>
      ))}
    </div>
  );
};

export const CollectionAdjacentCollectionsPlaceholder = memo(
  CollectionAdjacentCollectionsPlaceholderBase
);
